<script setup lang="ts">
  import { useAppModal } from '@/components/modal'
  import { useAuthStore } from '@/stores/auth'

  const { modal, open, close } = useAppModal()
  const authStore = useAuthStore()

  const selectTenant = (tenant: Tenant) => {
    authStore.setTenantSelected(tenant)
    close()
  }
</script>

<template>
  <div>
    <app-button
      class="link pointer-events-auto w-fit text-primary font-bold"
      @click="open">
      <div class="flex items-center text-white font-bold space-x-1">
        <div class="text-2xl">
          {{ authStore.tenantNameSelected }}
        </div>
        <fa-icon icon="i-fas-caret-down" />
      </div>
    </app-button>

    <app-modal
      ref="modal"
      title="Pilih Tenant">
      <div class="grid grid-cols-2 gap-4">
        <template
          v-for="tenant in authStore.tenants"
          :key="tenant">
          <div class="text-sm">
            <app-button
              class="link"
              @click="selectTenant(tenant)">
              {{ tenant.name }}
            </app-button>
          </div>
        </template>
      </div>

      <div class="absolute inset-x-0 bottom-4 flex justify-center">
        <app-button
          class="btn-primary"
          :to="{name: 'tenant list'}"
          @click="close">
          Kelola Tenant
        </app-button>
      </div>
    </app-modal>
  </div>
</template>
